// extracted by mini-css-extract-plugin
export default {"ConfirmationPop":"ConfirmationPop_ConfirmationPop__7TXnj","modalBody":"ConfirmationPop_modalBody__ZRwQO"};